class ProductTechSpecs extends HTMLElement {
  constructor() {
    super();
    this.showMoreButton = this.querySelector('[data-show-more-button]');
    this.container = this.querySelector('.product-tech-specs__container');
    this.hiddenItems = this.querySelectorAll('.product-tech-specs__item--hidden');
    this.showText = this.showMoreButton?.dataset.showText;
    this.hideText = this.showMoreButton?.dataset.hideText;
    this.isExpanded = false;
    this.isMobile = window.innerWidth < 768;
    this.visibleSpecs = this.isMobile ? 
      parseInt(this.container.dataset.visibleSpecsMobile) : 
      parseInt(this.container.dataset.visibleSpecs);

    this.handleResize = this.handleResize.bind(this);
    this.handleButtonKeydown = this.handleButtonKeydown.bind(this);
  }

  connectedCallback() {
    if (!this.showMoreButton) return;

    this.showMoreButton.addEventListener('click', (e) => this.toggleSpecs(e));
    this.showMoreButton.addEventListener('keydown', this.handleButtonKeydown);
    window.addEventListener('resize', this.handleResize);
    this.updateVisibility();
  }

  disconnectedCallback() {
    if (this.showMoreButton) {
      this.showMoreButton.removeEventListener('keydown', this.handleButtonKeydown);
    }
    window.removeEventListener('resize', this.handleResize);
  }

  handleButtonKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleSpecs(event, true);
    }
  }

  toggleSpecs(event, isKeyboard = false) {
    this.isExpanded = !this.isExpanded;

    const items = Array.from(this.querySelectorAll('.product-tech-specs__item'));

    items.forEach((item, index) => {
      if (index >= this.visibleSpecs && !this.isExpanded) {
        item.classList.add('product-tech-specs__item--hidden');
        item.setAttribute('aria-hidden', 'true');
      } else {
        item.classList.remove('product-tech-specs__item--hidden');
        item.removeAttribute('aria-hidden');
      }
    });

    const visualText = this.showMoreButton.querySelector('[aria-hidden="true"]');
    const srText = this.showMoreButton.querySelector('.visually-hidden');

    visualText.textContent = this.isExpanded ? this.hideText : this.showText;
    srText.textContent = this.isExpanded ? this.hideText : this.showText;
    this.showMoreButton.setAttribute('aria-expanded', this.isExpanded);

    if (this.isExpanded && isKeyboard) {
      const firstNewlyVisibleItem = items[this.visibleSpecs];

      if (firstNewlyVisibleItem) {
        setTimeout(() => {
          firstNewlyVisibleItem.focus();
        }, 10);
      }
    } else if (!this.isExpanded) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 768;

    if (wasMobile !== this.isMobile) {
      this.visibleSpecs = this.isMobile ? 
        parseInt(this.container.dataset.visibleSpecsMobile) : 
        parseInt(this.container.dataset.visibleSpecs);

      this.updateVisibility();
    }
  }

  updateVisibility() {
    const items = Array.from(this.querySelectorAll('.product-tech-specs__item'));

    items.forEach((item, index) => {
      if (index >= this.visibleSpecs && !this.isExpanded) {
        item.classList.add('product-tech-specs__item--hidden');
        item.setAttribute('aria-hidden', 'true');
      } else {
        item.classList.remove('product-tech-specs__item--hidden');
        item.removeAttribute('aria-hidden');
      }
    });
  }
}

customElements.define('product-tech-specs', ProductTechSpecs); 